import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6c2e2b92&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=6c2e2b92&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2e2b92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c2e2b92')) {
      api.createRecord('6c2e2b92', component.options)
    } else {
      api.reload('6c2e2b92', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6c2e2b92&scoped=true&", function () {
      api.rerender('6c2e2b92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/xmy/page/index.vue"
export default component.exports